(ns practitest.frontend.user-activity-log.main
  (:require [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.user-activity-log.views :as views]
            [practitest.frontend.user-activity-log.events :as events]
            [practitest.frontend.user-activity-log.subs :as subs]
            [re-frame.core :as re-frame]
            [reagent.dom :as rdom]))

(defn user-activity-log-view []
  (if-let [_init-done? @(re-frame/subscribe [::subs/init-complete?])]
    [views/main-panel]
    [:div.loader
     [spinners/mux-spinner {:size :modal}]]))

(defn ^:export legacy_init [config]
  (re-frame/dispatch [::events/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [::events/init-complete])
  (when-let [root (js/document.getElementById "user-activity-log-root")]
    (rdom/render [user-activity-log-view] root)))
